/**
 * @author Mark Cremer <mark@firstcoders.co.uk>
 */
angular.module('pitch.app')
.directive('satvPlayPanel', function($document, $window, $timeout, TrackInfoSimpleModal) {
    "use strict";

    return {
        scope: {
            loader: '=satvPlayPanel',
            heading: '=',
            context: '=',
            auditionFormat: '=',
            isDownloadable: '=',
            isPlayable: '=',
            showInfoButton: '=',
            showMasters: '=',
            pitch: '='
        },
        restrict: 'A',
        replace: true,
        compile: function(element, attrs) {
            attrs.isPlayable = attrs.isPlayable || 'true';

            return {
                pre: function preLink($scope, elem, attr) {
                },
                post: function postLink($scope, elem, attr) {
                    var $container, $containerInner, maxOffset, delta;

                    $container            = angular.element(elem[0].querySelector('.scroll-container'));
                    $containerInner       = angular.element(elem[0].querySelector('.scroll-container-inner'));
                    $scope.scrollTop      = 0;
                    $scope.showDown       = false;
                    $scope.showUp         = false;
                    $scope.isScrollable   = true;
                    delta                 = 60;

                    //modelProperty is cascaded into the media-list.
                    $scope.modelProperty  = attr.modelProperty || '';

                    function adjustScroll(index) {
                        var newOffset;

                        maxOffset = $containerInner[0].offsetHeight - $container[0].offsetHeight;
                        newOffset = $scope.scrollTop + (index * delta);
                        newOffset = newOffset > maxOffset ? maxOffset : newOffset;

                        $scope.scrollTop = newOffset;
                        $scope.showUp = newOffset > 0;
                        $scope.showDown = newOffset < maxOffset;

                        $containerInner.css('transform', 'translate(0px, -' + $scope.scrollTop + 'px)');
                    }

                    $scope.up = function() {
                        adjustScroll(-3);
                    };

                    $scope.down = function() {
                        adjustScroll(+3);
                    };

                    // ---
                    // INITIALIZATION OF HEIGHT ETC.

                    var redrawTimeout;

                    var setIsScrollable = function() {
                        $scope.isScrollable = $containerInner[0].offsetHeight > $container[0].offsetHeight;
                        $scope.scrollTop = 0;
                        adjustScroll(0);
                    };

                    var redraw = function() {
                        $timeout.cancel(redrawTimeout);
                        redrawTimeout = $timeout(setIsScrollable, 100);
                    };

                    //create a watch to observe when the loader items have been rendered..
                    //only then readjust the height and show any scroll buttons etc.
                    //we wrap it in a timeout for increased performance upon pageload
                    $timeout(function() {
                        var renderWatch = $scope.$watch(function() {
                            return $containerInner[0].offsetHeight;
                        }, function(height) {
                            if (height > 0) {
                                setIsScrollable();
                                // clear the watch
                                renderWatch();
                            }
                        });
                    }, 500);

                    //re-inialize when the window resizes
                    angular.element($window).on('resize', redraw);

                    $scope.$on('$destroy', function() {
                        angular.element($window).off('resize', redraw);
                    });
                }
            };
        },
        controller: function($scope) {
            //this directive is made to work with featured tracks in the form of an
            //array of content-references ({id:1, subject: ... the track ...}) (see contentbundle)
            //and an array of actual tracks.. this helper method returns the real track
            //for every scenario.

            $scope.getRealTrack = function(t) {
                return t.subject ? t.subject : t;
            };

            $scope.info = function(track) {
                TrackInfoSimpleModal.open({}, {
                    track: track
                });
            };

            $scope.isMasters = function(track) {
                return track.category_name && track.category_name.toLowerCase().indexOf('masters') !== -1;
            };

            $scope.isPreRelease = function(track) {
                return track.category_name && track.category_name.toLowerCase().indexOf('pre-release') !== -1;
            };
        },
        template:   '<div class="panel panel-bare panel-dark play-panel shadow-box" ng-class="::{\'scroll-panel\': isScrollable, \'with-download\': isDownloadable}">' +
                        '<div class="panel-heading" ng-if="::heading">[[::heading]]</div>' +
                        '<div class="panel-body scroll-panel-wrapper">' +
                            '<button class="btn-animate btn btn-primary btn-up" ng-if="isScrollable" ng-show="showUp" ng-click="up()">' +
                                '<i class="fa fa-caret-up" aria-hidden="true"></i><span class="sr-only">Scroll Down</span>' +
                            '</button>' +
                            '<div satv-media-list="loader" model-property="[[::modelProperty]]" class="scroll-container">' +
                                '<div class="scroll-container-inner animate-transform fast">' +
                                    '<div class="play-panel-link play-panel-track btn-animate" ng-class="{\'is-playing\' : isPlaying(track)}" ng-repeat="item in loader.data" ng-init="::track = getRealTrack(item);">' +

                                        '<div class="btn-group" ng-if="::isDownloadable || showInfoButton">' +
                                            '<div ng-if="::showInfoButton" role="button" class="btn btn-animate" ga-track-event="[\'track\', \'info\', track.id]">' +
                                                '<div ng-click="info(track, $event)">' +
                                                    '<i aria-hidden="true" class="icon fa fa-info"></i><span class="sr-only">Info</span>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div ng-if="::isDownloadable && !isPreRelease(track) && !track.disabled" role="button" class="btn btn-animate" ga-track-event="[\'track\', \'download\', track.id]">' +
                                                '<div ng-click="download(track, $event, context)">' +
                                                    '<i aria-hidden="true" class="icon fa fa-download"></i><span class="sr-only">Download</span>' +
                                                '</div>' +
                                            '</div>' +
                                            '<favourite-btn ng-if="::pitch && isDownloadable && !isPreRelease(track) && !track.disabled" pitch="pitch" track="track"></favourite-btn>' +
                                        '</div>' +

                                        '<div role="button" ng-class="::{\'disabled\': !isPlayable || track.disabled}" class="btn-play" ng-click="isPlayable && !track.disabled && play(track, $event, context, auditionFormat)" ga-track-event="[\'track\', \'play\', track.id]">' +
                                            '<div class="text-center shadow-box play-panel-btn">' +
                                                '<div class="icon-circle small">' +
                                                    '<div class="circle btn-animate">' +
                                                        '<i aria-hidden="true" class="icon fa fa-play"></i><span class="sr-only">Play</span>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div class="play-panel-details">' +
                                                '<div class="no-break title text-uppercase">' +
                                                    '<span>[[::track.full_name || track.name]]</span>' +
                                                    '<small ng-if="::isMasters(track)" class="badge badge-sm-em spaced-left-sm" satv-tooltip="Owned Masters"><i class="fa fa-certificate" aria-hidden="true"></i> Master<span class="sr-only">Owned Masters</span></small>' +
                                                    '<small ng-if="::isPreRelease(track)" class="badge badge-sm-em spaced-left-sm" satv-tooltip="Pre-release"><i class="fa fa-certificate" aria-hidden="true"></i> Pre-release<span class="sr-only">Pre-release</span></small>' +
                                                '</div>' +
                                                '<div class="no-break text-muted"><small>[[::track.artist_names.join(\', \') || \'Unknown artist\']]</small></div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="text-center" satv-status-icon is-empty="loader.isEmpty" is-loading="loader.isLoading"></div>' +
                            '</div>' +
                            '<button class="btn-animate btn btn-primary btn-down" ng-if="isScrollable" ng-show="showDown" ng-click="down()">' +
                                '<i class="fa fa-caret-down" aria-hidden="true"></i><span class="sr-only">Scroll Down</span>' +
                            '</button>' +
                        '</div>' +
                    '</div>'
    };
});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/playPanel.js